import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Icon, InlineWarning } from '@driftt/tide-core-legacy'
import { Select } from '@driftt/tide-core-legacy'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router'

import LeanDataError from './components/LeanDataError'
import LeanDataConnected from './components/LeanDataConnected'
import LeanDataDisconnected from './components/LeanDataDisconnected'

import { CONVERSATION_API } from 'constants/ResourcesConstants'
import ldIconSrc from 'images/logos/leandata-with-name.svg'
import greenCheckCircleIconSrc from 'images/svg/green-check-circle.svg'
import { LeanDataAuthStatuses } from 'app/modules/integrations/constants'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as IntegrationsActions from 'app/modules/integrations/actions'
import * as IntegrationsSelectors from 'app/modules/integrations/selectors'

import './style.styl'

const LEANDATA_INTEGRATION_SWITCH = 'leandata-integration-switch'

const NO_ERROR_VALUE = LeanDataAuthStatuses.NO_ERROR

const makeGetLeanDataAuthStatusConfig = (successCallback) => ({
  url: `${CONVERSATION_API}/integration/test/leandata/authorization`,
  method: 'get',
  data: {},
  successMessage: ``,
  errorMessage: ``,
  successCallback,
})

class LeanData extends React.PureComponent {
  constructor(props) {
    super(props)
  
    this.state = {
      leandataConnectedWithAccess: false, 
      leandataConnectedWithNoAccess: false, 
      leandataNotConnected: true,
    }
  }

  componentDidMount() {
    this.props.actions.getLeanDataAuthStatus()
  }

  componentDidUpdate(prevProps, prevState) {
    const newValue = this.props.leandataAuthenticationStatus.get("value")
    const a = LeanDataAuthStatuses
    if (newValue && prevProps.leandataAuthenticationStatus.value !== newValue) {
      this.setState({
        leandataConnectedWithAccess: this.props.leandataConnected && newValue === NO_ERROR_VALUE, 
        leandataConnectedWithNoAccess: this.props.leandataConnected && newValue !== NO_ERROR_VALUE, 
      })
    }
  }

  render() {
    const {
      salesforceConnected,
      leandataConnected
    } = this.props
    return (
      <div className="integration-leandata-container">
        <div className="integration-leandata-title-container">
          <h1>
            <img className="integration-leanddata-title-icon" src={ldIconSrc} />
          </h1>
          <span>
          {this.state.leandataConnectedWithAccess && <span className="integration-leandata-title-connected"><img src={greenCheckCircleIconSrc} />Connected</span>}
          {this.state.leandataConnectedWithNoAccess && <span className="integration-leandata-title-incomplete"><Icon className="incomplete-icon" name="warning-triangle"/> INCOMPLETE</span>}
          </span>
        </div>
        {this.state.leandataConnectedWithAccess && 
          <LeanDataConnected 
            asyncButtonPress={this.props.actions.asyncButtonPress} 
            togglePending={this.props.togglePending} 
            integrationsFetchPending={this.props.integrationsFetchPending}
            fetchIntegrationStates={this.props.actions.fetchIntegrationStates} 
          />
        }
        {this.state.leandataConnectedWithNoAccess && 
          <LeanDataError
            error={this.props.leandataAuthenticationStatus.get("value")}
          />}
        {!this.props.leandataConnected && 
          <LeanDataDisconnected
            asyncButtonPress={this.props.actions.asyncButtonPress} 
            togglePending={this.props.togglePending} 
            integrationsFetchPending={this.props.integrationsFetchPending}
            fetchIntegrationStates={this.props.actions.fetchIntegrationStates} 
          />
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    salesforceConnected: IntegrationsSelectors.isConnectedTo(state, 'salesforce'),
    leandataConnected: IntegrationsSelectors.isConnectedTo(state, 'leandata'),
    integrationsFetchPending: IntegrationsSelectors.connectionsFetchPending(state),
    togglePending: PlaybookSelectors.asyncButtonPending(state, LEANDATA_INTEGRATION_SWITCH),
    leandataAuthenticationStatus: IntegrationsSelectors.getLeanDataAuthStatus(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      updateIntegrationState: IntegrationsActions.updateIntegrationState,
      asyncButtonPress: PlaybookActions.asyncButtonPress,
      fetchIntegrationStates: IntegrationsActions.fetchIntegrationStates,
      getLeanDataAuthStatus: IntegrationsActions.getLeanDataAuthStatus
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(LeanData)


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/LeanData/index.js